export const contacts = [
  { label: "Direct email", handle: "nuno_miranda@outlook.com", href: "mailto:nuno_miranda@outlook.com?subject=Project%20with%20Nuno%20Miranda", tone: "purple" },
  { label: "YouTube Channel", handle: "@devspotacademy", href: "https://youtube.com/@devspotacademy", tone: "red" },
  { label: "LinkedIn", handle: "@0xnunomiranda", href: "https://www.linkedin.com/in/0xnunomiranda/", tone: "blue" },
  { label: "Udemy Courses", handle: "@devspotacademy", href: "https://www.udemy.com/user/devspotacademy/?srsltid=AfmBOoqahN_oGCnEGad0Iq5shwhDrtJZ51Z-Nh3BGKTs3U3l4DWOyTcH", tone: "purple" },
  { label: "GitHub", handle: "@0xNunoMiranda", href: "https://github.com/0xNunoMiranda", tone: "green" }
];

// Transcribed and translated from the PDF embedded in the original blog's About me / CV.
// Retrieved 2026-09-17. Professional history: pp. 2-3; education: p. 3;
// historical projects: pp. 1 and 4; courses/certificates: pp. 8-13.
// Original source is retained for maintenance; no external embed is needed at runtime.
export const cvSource = {
  blogUrl: "https://0xmiranda.blogspot.com/p/about-me.html",
  pdfUrl: "https://files.elfsightcdn.com/eafe4a4d-3436-495d-b748-5bdce62d911d/ed801006-3690-4b3c-97eb-7ec82edc8725/4627b7ba-0508-427f-82f8-5c38a87918e4_CV_-_Nuno_Miranda.pdf",
  retrievedAt: "2026-09-17"
};

export const cv = {
  name: "Nuno Miranda",
  role: "Fullstack Developer · JavaScript & .NET",
  location: "Portugal",
  summary:
    "I hold a degree in Computer Engineering from ISPGAYA and build applications with JavaScript and .NET. My experience spans healthcare software, payment integrations and mobile applications, with a focus on APIs, microservices and connecting systems.",
  highlights: [
    "Clinical software and healthcare system integrations",
    "APIs and microservices with .NET, Node.js and TypeScript",
    "Payment, CRM and communications integrations",
    "Web and mobile applications and interactive experiences"
  ],
  skills: [
    "C#", ".NET", "Minimal APIs", "Blazor", "Node.js", "TypeScript",
    "JavaScript", "React", "React Native", "HTML", "CSS", "SQL Server",
    "PHP", "Ionic", "Java", "Unity", "GitHub"
  ],
  experience: [
    {
      title: "Developer",
      organization: "Imaginasoft",
      sector: "Healthcare Solutions",
      period: "2021 - present",
      description: "Healthcare software development, initially using Node.js and TypeScript, followed by .NET APIs with Minimal APIs.",
      contributions: [
        "A ticketing system built in Node.js and migrated to .NET, integrating Tawk.to, Bitrix24 CRM and a technical support form.",
        "Microservices for registering invoice series with the Portuguese Tax Authority, Multibanco and MB WAY payments through SIBS Payments, and patient, doctor and appointment management in Newsoft.",
        "Integrations with Multicare, ADSE and AdvanceCare, and an AI call assistant for clinics.",
        "Webphone integration with Yeastar Linkus and Newsoft for making and receiving calls; support for developing a 3D dental chart in Unity."
      ]
    },
    {
      title: "Developer / Support",
      organization: "euPago",
      sector: "Payments Provider",
      period: "2021 · 7 months",
      description: "Payment software development and technical support, including work on customer PHP scripts.",
      contributions: []
    },
    {
      title: "Store assistant",
      organization: "Jerónimo Martins · Pingo Doce",
      sector: "Grijó, Vila Nova de Gaia",
      period: "2016 - 2019",
      description: "Store assistant and stock replenishment at Pingo Doce in Grijó.",
      contributions: []
    }
  ],
  education: [
    {
      title: "Bachelor's degree in Computer Engineering",
      institution: "ISPGAYA · Instituto Superior Politécnico Gaya",
      period: "2016 - 2020",
      detail: "Degree completed in September 2020."
    },
    {
      title: "Electrical Installation Technician",
      institution: "ISQ · Instituto de Soldadura e Qualidade",
      period: "2012 - 2015",
      detail: "Upper secondary qualification, level 4. ITED / TIE professional certification."
    },
    {
      title: "Secondary education",
      institution: "Escola Secundária ES/3 dos Carvalhos",
      period: "2007 - 2010",
      detail: "Secondary school attendance (not completed during this period)."
    }
  ],
  degreeDocuments: [
    {
      title: "Bachelor's degree certificate",
      description: "ISPGAYA certificate of completion for the Bachelor's degree in Computer Engineering.",
      image: "/diploma/ispgaya-degree-certificate.webp"
    },
    {
      title: "Degree transcript — part 1",
      description: "Official ISPGAYA academic record accompanying the degree certificate.",
      image: "/diploma/ispgaya-degree-transcript-1.webp"
    },
    {
      title: "Degree transcript — part 2",
      description: "Continuation of the official ISPGAYA academic record.",
      image: "/diploma/ispgaya-degree-transcript-2.webp"
    }
  ],
  training: [
    { title: "React - The Complete Guide 2024", provider: "Udemy · Maximilian Schwarzmüller", year: "2024" },
    { title: "NLW Expert · C# and .NET", provider: "Rocketseat", year: "2024" },
    { title: "Complete PHP 7 Course", provider: "Udemy", year: "2024" },
    { title: "Essential ASP.NET Core Web API (.NET 6)", provider: "Udemy · Macoratti", year: "2023" },
    { title: "Getting Started with .NET on AWS", provider: "AWS Training and Certification", year: "2023" },
    { title: "Ignite · Node.js", provider: "Rocketseat", year: "2022" },
    { title: "The Complete Node.js Developer Course (3rd Edition)", provider: "Udemy", year: "2021" },
    { title: "Web Development · Build 6 Projects", provider: "Udemy", year: "2019" },
    { title: "C# Programming Fundamentals", provider: "AprendaUnity", year: "2016" },
    { title: "Crossy Road", provider: "AprendaUnity", year: "2016" }
  ],
  historicalProjects: [
    {
      title: "ISPGAYA App",
      period: "Sep - Nov 2020",
      kind: "Client project",
      summary: "An information app for ISPGAYA built with React Native and Node.js. The original resume records its release on Google Play and the App Store.",
      technologies: ["React Native", "Node.js"],
      siteSlug: null
    },
    {
      title: "VFCONSULTINGGROUP App",
      period: "Aug - Nov 2018",
      kind: "Client project",
      summary: "A consultancy mobile app for customer authentication, balance enquiries and access to tax documents. Built with an Ionic frontend and a PHP backend connecting to existing systems.",
      technologies: ["Ionic", "Angular", "TypeScript", "SCSS", "PHP"],
      siteSlug: null
    },
    {
      title: "Super Road 3D Game",
      period: "Feb 2017",
      kind: "Personal project",
      summary: "A 3D game built with Unity and C#. Originally released on Facebook GameRoom and included in this portfolio.",
      technologies: ["Unity", "C#"],
      siteSlug: "unity-super-road"
    }
  ]
};
